import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface HeroV2Props {
  onSubmit: (plz: string) => void;
}
export function HeroV2({
  onSubmit
}: HeroV2Props) {
  const [plz, setPlz] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\d{4}$/.test(plz)) {
      setError('Bitte geben Sie eine gültige 4-stellige Postleitzahl ein');
      return;
    }
    setError('');
    onSubmit(plz);
  };
  return <section className="relative bg-ofri-blue" data-id="element-19">
      {/* Background image */}
      <div className="absolute inset-0" data-id="element-20">
        <img src="https://cdn.magicpatterns.com/uploads/8jqDBkQ9n1mmF8oaBXtu5c/ChatGPT_Image_11._Mai_2026,_15_32_30.png" alt="" className="w-full h-full object-cover object-left-top" data-id="element-21" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/30 to-transparent" data-id="element-22" />
      </div>

      {/* Content */}
      <div className="relative max-w-2xl lg:max-w-4xl mx-auto px-4 py-16 sm:py-28 text-center" data-id="element-23">
        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight leading-tight" data-id="element-24">
          Maler Offerten vergleichen
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-base sm:text-xl text-ofri-blue-light mb-8 sm:mb-10" data-id="element-25">
          Bis zu 5 kostenlose Offerten von geprüften Malerfirmen in Ihrer
          Region.
        </motion.p>

        <motion.form initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} onSubmit={handleSubmit} className="max-w-lg mx-auto" data-id="element-26">
          <div className="flex flex-col sm:flex-row gap-2 bg-white p-2 rounded-xl shadow-2xl" data-id="element-27">
            <input type="text" inputMode="numeric" maxLength={4} value={plz} onChange={e => setPlz(e.target.value.replace(/\D/g, ''))} placeholder="Ihre Postleitzahl, z.B. 8001" className="flex-1 px-4 py-3 text-lg text-gray-900 placeholder-gray-400 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-ofri-blue focus:ring-2 focus:ring-ofri-blue/30 transition-colors" aria-label="Postleitzahl" data-id="element-28" />
            <button type="submit" className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-29">
              Offerten erhalten
              <ArrowRightIcon className="w-5 h-5" data-id="element-30" />
            </button>
          </div>
          {error && <p className="mt-3 text-sm text-white bg-red-600/90 inline-block px-3 py-1 rounded" data-id="element-31">
              {error}
            </p>}
          <p className="mt-4 text-sm text-ofri-blue-light" data-id="element-32">
            Kostenlos · Unverbindlich · In 2 Minuten erledigt
          </p>
        </motion.form>
      </div>
    </section>;
}